import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import {voltronIconNames} from '../../../util/uiconstants';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import Button from '../BaseComponentWrappers/MotifButton';
import Icon from '../BaseComponentWrappers/MotifIcon';

export default function ClickableIconLabel({
	styleName,
	className,
	disabled,
	text,
	iconName,
	onClick,
	tooltip,
	iconPositionLeft
}) {
	const isVoltronIcon = voltronIconNames.indexOf(iconName) !== -1;

	// If no tooltip prop is provided, show the text as the tooltip
	const tooltipText = tooltip || text;

	function handleOnIconClick(evt) {
		if (disabled) {
			return false;
		} else {
			onClick && onClick(evt);
		}
	}

	let styledClassName = `StyledClickableIconLabel`;
	styledClassName += className ? ` ${className}` : '';
	styledClassName += styleName ? ` ${styleName}` : '';
	styledClassName += disabled ? ' disabled' : '';

	const getEllipsesControl = (text, tooltipText) => {
		return <EllipsesControl content={text} tooltip={tooltipText} noOfLines={1} tooltipClass="ClickableIconLabelText" />;
	};

	return (
		<StyledClickableIconLabel className={`StyledClickableIconLabel ${styledClassName}`}>
			{isVoltronIcon ? (
				<section className="voltron-icon-container" onClick={handleOnIconClick}>
					{iconPositionLeft ? (
						<>
							{getEllipsesControl(text, tooltipText)}
							{iconName && <SVGICONS styleName="large" name={iconName} hoverText={tooltipText} />}
						</>
					) : (
						<>
							{iconName && <SVGICONS styleName="large" name={iconName} hoverText={tooltipText} />}
							{getEllipsesControl(text, tooltipText)}
						</>
					)}
				</section>
			) : (
				<Button
					disabled={disabled}
					variant="text-alt"
					onClick={handleOnIconClick}
					className="motif-icon-container"
					children={
						iconPositionLeft ? (
							<>
								{getEllipsesControl(text, tooltipText)}
								{iconName && <Icon src={iconName} title={tooltipText} />}
							</>
						) : (
							<>
								{iconName && <Icon src={iconName} title={tooltipText} />}
								<EllipsesControl
									content={text}
									tooltip={tooltipText}
									noOfLines={1}
									tooltipClass="ClickableIconLabelText"
								/>
							</>
						)
					}
				/>
			)}
		</StyledClickableIconLabel>
	);
}

ClickableIconLabel.propTypes = {
	onClick: PropTypes.func,
	className: PropTypes.string,
	iconName: PropTypes.string.isRequired,
	text: PropTypes.string,
	tooltip: PropTypes.string
};

const StyledClickableIconLabel = styled.section`
	.voltron-icon-container {
		display: flex;
		color: var(--blue-600);
		font-size: var(--px-14);
		font-weight: bold;
		cursor: pointer;
		svg {
			cursor: pointer;
			fill: var(--blue-600);
			path {
				fill: var(--blue-600);
			}
			& + section {
				max-width: var(--px-120);
				margin-left: var(--px-5);
			}
		}
	}
	.motif-text-alt-button {
		.motif-icon {
			svg {
				fill: none !important;
			}
		}
	}
`;
